import { EmptySection } from '../components/Card.jsx';

/* TODO: inbound routing rules (business hours, IVR, out-of-hours voicemail,
   mobile failover) alongside the resulting active flow. Tenant admin only. */
export default function CallRouting() {
  return (
    <EmptySection
      title="Call routing"
      body="Your inbound routing rules will appear here, with a live view of how a call to your DID is routed."
    />
  );
}
